module.exports = __webpack_public_path__ + "img/ring_r_0_1_1@2x.5d1fe687.png";